var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('avue-form-design',{staticStyle:{"height":"100vh"},attrs:{"options":_vm.options,"storage":"","show-avue-doc":""},on:{"submit":_vm.handleSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }